<template>
  <div class="forum-wrapper">
    <v-container fluid class="forum-dashboard-container">
      <v-row justify="center">
        <v-col cols="12" sm="8" md="6">
          <v-card outlined class="forum-card">
            <v-card-title class="text-h5">Create New Thread</v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-select
                  v-model="formData.category"
                  :items="categories"
                  item-title="name"
                  item-value="id"
                  label="Category"
                  :rules="[rules.required]"
                  variant="outlined"
                  dense
                  required
                ></v-select>
                <v-text-field
                  v-model="formData.title"
                  label="Thread Title"
                  :rules="[rules.required]"
                  variant="outlined"
                  dense
                  required
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="success" @click="createThread">Create</v-btn>
              <v-btn variant="text" @click="cancel">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ForumThreadCreate",
  data() {
    return {
      valid: false,
      formData: {
        category: null,
        title: "",
      },
      categories: [],
      rules: {
        required: (v) => !!v || "Required",
      },
    };
  },
  methods: {
    async fetchCategories() {
      try {
        const res = await axios.get("/api/forum-categories/", {
          withCredentials: true,
        });
        const data = res.data.results ? res.data.results : res.data;
        this.categories = data.map((cat) => ({
          id: cat.id,
          name:
            typeof cat.name === "object" ? cat.name.text : cat.name,
        }));
      } catch (error) {
        console.error("Error loading categories:", error);
      }
    },
    async createThread() {
      if (!this.$refs.form.validate()) return;
      try {
        const categoryId =
          typeof this.formData.category === "object"
            ? this.formData.category.id
            : this.formData.category;
        await axios.post(
          "/api/forum-threads/",
          {
            category: categoryId,
            title: this.formData.title,
          },
          { withCredentials: true }
        );
        this.$router.push("/forum");
      } catch (error) {
        console.error("Error creating thread:", error);
      }
    },
    cancel() {
      this.$router.push("/forum");
    },
  },
  created() {
    this.fetchCategories();
  },
  mounted() {
    setTimeout(() => {
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }, 200);
  },
};
</script>

<style scoped>
.forum-wrapper {
  overflow: hidden;
}

.forum-dashboard-container {
  background: linear-gradient(to bottom, #fafafa, #e7effa, #d2e3f5);
  padding: 20px;
  min-height: 100vh;
  position: relative;
}

.forum-card {
  background-color: #fff;
  border-radius: 8px;
}
</style>